module.exports = __webpack_public_path__ + "static/media/logos_50h_colorado.8b655e32.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/conf/logo_bar/logos_50h_colorado.jpg
// module id = 214
// module chunks = 0